"use client";
import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import styles from "./CouponInfoModal.module.css";

//test

export default function CouponInfoModal({ open, onClose, coupon }) {
    const [leaving, setLeaving] = useState(false);
    const closeRef = useRef(null);

    // 👇 dodaj ovo:
    const hideCode =
        coupon?.title === "100% Cashback on First Deposit" ||
        coupon?.code === "CASHBACK100";

    useEffect(() => {
        if (!open) return;
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        setTimeout(() => closeRef.current?.focus(), 0);
        const onKey = (e) => e.key === "Escape" && handleClose();
        window.addEventListener("keydown", onKey);
        return () => {
            document.body.style.overflow = prev;
            window.removeEventListener("keydown", onKey);
            setLeaving(false);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    if (!open) return null;

    const handleClose = () => {
        setLeaving(true);
        setTimeout(onClose, 220);
    };

    return createPortal(
        <div
            className={`${styles.backdrop} ${leaving ? styles.fadeOut : ""}`}
            onClick={handleClose}
            aria-hidden="true"
        >
            <div
                className={`${styles.modal} ${leaving ? styles.modalOut : ""}`}
                role="dialog"
                aria-modal="true"
                aria-labelledby="coupon-title"
                aria-describedby="coupon-desc"
                onClick={(e) => e.stopPropagation()}
            >
                <div className={styles.header}>
                    <h3 id="coupon-title">
                        {hideCode ? (
                            // za cashback kupon ne prikazujemo kod u naslovu
                            <>Coupon details</>
                        ) : (
                            <>
                                <span>CODE: </span> {coupon?.code || "Coupon details"}
                            </>
                        )}
                    </h3>
                    <button ref={closeRef} className={styles.close} onClick={handleClose} aria-label="Close">×</button>
                </div>

                <div id="coupon-desc" className={styles.content}>
                    {coupon?.badge && <div className={styles.badge}>{coupon.badge}</div>}
                    <div className={styles.rows}>
                        {coupon?.bonus && (
                            <div className={styles.row}>
                                <span>Bonus</span><b>{coupon.bonus}</b>
                            </div>
                        )}
                        {coupon?.mco && (
                            <div className={styles.row}>
                                <span>MCO</span><b>{coupon.mco}</b>
                            </div>
                        )}
                        {coupon?.minDeposit && (
                            <div className={styles.row}>
                                <span>Min Deposit</span><b>{coupon.minDeposit}</b>
                            </div>
                        )}
                        {coupon?.wagering && (
                            <div className={styles.row}>
                                <span>Wagering</span><b>{coupon.wagering}</b>
                            </div>
                        )}
                        {coupon?.maxBet && (
                            <div className={styles.row}>
                                <span>Max Bet</span><b>{coupon.maxBet}</b>
                            </div>
                        )}
                        {coupon?.maxBonus && (
                            <div className={styles.row}>
                                <span>Max Bonus</span><b>{coupon.maxBonus}</b>
                            </div>
                        )}
                        {coupon?.games && (
                            <div className={styles.row}>
                                <span>Games</span><b>{coupon.games}</b>
                            </div>
                        )}
                        {coupon?.available && (
                            <div className={styles.row}>
                                <span>Available</span><b>{coupon.available}</b>
                            </div>
                        )}
                        {coupon?.code && !hideCode && (
                            <div className={styles.row}>
                                <span>Code</span>
                                <b>{coupon.code}</b>
                            </div>
                        )}
                        {coupon?.infoText && (
                            <div className={styles.row}>
                                <span>Info</span><b>{coupon.infoText}</b>
                            </div>
                        )}
                    </div>

                    {coupon?.terms?.length ? (
                        <ul className={styles.terms}>
                            {coupon.terms.map((t, i) => <li key={i}>{t}</li>)}
                        </ul>
                    ) : null}
                </div>

                <div className={styles.actions}>
                    {/* {coupon?.ctaHref && (
                        <a className={styles.primary} href={coupon.ctaHref}>
                            {coupon.ctaText || "Claim Now"}
                        </a>
                    )} */}
                    <button className={styles.secondary} onClick={handleClose}>Close</button>
                </div>
            </div>
        </div>,
        document.body
    );
}
